import React from 'react';

const Logout: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M10.2637 2.34473C10.874 2.40535 11.4482 2.67581 11.8857
      3.11328C12.3857 3.61329 12.6669 4.29197 12.667 4.99902V6.66504C12.667
      7.21722 12.2191 7.66486 11.667 7.66504C11.1147 7.66504 10.667 7.21732
      10.667 6.66504V4.99902C10.6669 4.82241 10.5965 4.65228 10.4717
      4.52734C10.378 4.4337 10.2589 4.37034 10.1309 4.34473L10 4.33203H4.16699C3.99026
      4.33203 3.82032 4.40242 3.69531 4.52734C3.57037 4.65229 3.50009 4.82233
      3.5 4.99902V14.999C3.50009 15.1756 3.57057 15.3448 3.69531 15.4697C3.82034
      15.5948 3.99018 15.665 4.16699 15.665H10C10.1768 15.665 10.3467 15.5948
      10.4717 15.4697C10.5963 15.3448 10.6669 15.1755 10.667 14.999V13.332C10.6672
      12.7799 11.1148 12.332 11.667 12.332C12.219 12.3322 12.6668 12.78 12.667
      13.332V14.999C12.6669 15.7061 12.3857 16.3848 11.8857 16.8848C11.3857
      17.3848 10.7072 17.665 10 17.665H4.16699C3.4599 17.665 2.78132 17.3847
      2.28125 16.8848C1.78133 16.3848 1.50009 15.7061 1.5 14.999V4.99902C1.50009
      4.2919 1.78123 3.6133 2.28125 3.11328C2.78133 2.61329 3.45983 2.33203
      4.16699 2.33203H10L10.2637 2.34473ZM7.62598 6.79199C8.01645 6.40152 8.6495
      6.40163 9.04004 6.79199C9.43056 7.18252 9.43056 7.81553 9.04004
      8.20605L8.24707 8.99902H16.666L16.7686 9.00391C17.2728 9.05509 17.666
      9.48124 17.666 9.99902C17.666 10.5168 17.2728 10.943 16.7686 10.9941L16.666
      10.999H8.24707L9.04004 11.792L9.1084 11.8682C9.42875 12.2609 9.40616
      12.8399 9.04004 13.2061C8.67391 13.572 8.09486 13.5947 7.70215
      13.2744L7.62598 13.2061L5.12598 10.7061C4.73567 10.3156 4.73567 9.68248
      5.12598 9.29199L7.62598 6.79199Z`} fill="#98A2B3"/>
  </svg>
);

export default Logout;
